import { withInstall } from '../utils'
import _Infiniteload from './Infiniteload'
import './index.scss'

export const Infiniteload = withInstall(_Infiniteload)
export default Infiniteload
